import {
	Box,
	CircularProgress,
	type CircularProgressProps,
} from '@mui/material'

export type LoadingProps = {
	size?: number
	color?: CircularProgressProps['color']
}

function Loading({ size = 80, color = 'primary' }: LoadingProps) {
	return (
		<Box
			sx={{
				position: 'absolute',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				display: 'grid',
				placeContent: 'center',
				zIndex: 1,
			}}
			role="alert"
			aria-busy="true"
		>
			<CircularProgress size={size} color={color} />
		</Box>
	)
}

export { Loading, Loading as default }
